<ngx-spinner bdColor = "rgba(51,51,51,0.8)" 
             size = "medium" 
             type = "square-jelly-box" 
             [fullScreen] = "true">
             <p style="color: #fff"> 
              <i class="fa fa-spinner fa-pulse fa-spin fa-5x fa-fw"></i>
              <br/>
              <span class="sr-only fw-bold h4">Aguarde</span>
             </p>
</ngx-spinner>
<app-header></app-header>
<div class="container-fluid">
    <main role="main" class="page-content-wrapper">
      <div class="page-content">
        <router-outlet>
        </router-outlet>
      </div>
    </main>
</div>

  <!-- <app-footer></app-footer> -->
